import React, { useEffect, useState, useRef, memo } from 'react'
import { Redirect } from 'react-router-dom'
import { Box, Typography } from 'transfix-ui/core'
import * as Api from 'apps/fleet-planner/utils/api'
import { Container } from 'components/layout'
import { getUrlParams } from 'utils/getUrlParams'

export const FP_QUICKBOOKS_URLS = {
  loading: '/user/settings/integrations?status=loading',
  error: '/user/settings/integrations?status=error',
  success: '/user/settings/integrations?status=success',
}

export const QuickBooksCallback = memo(() => {
  const { code, realmId, state } = getUrlParams()
  const [isValid, setIsValid] = useState<boolean | undefined>(undefined)

  /**
   * Trigger API callback method to Fleet Planner
   * @note This should trigger only once
   */
  const apiCalled = useRef(false)
  useEffect(() => {
    async function handleAuthCallback() {
      if (code && state && realmId) {
        try {
          await Api.exchangeAuthCodeStore({ code, state, realmId })
          setIsValid(true)
        } catch (e) {
          setIsValid(false)
        }
      }
    }

    if (!apiCalled.current) {
      handleAuthCallback()
      apiCalled.current = true
    }
  }, [code, state, realmId])

  // Proceed when response is true or false
  const isResponseReady = typeof isValid === 'boolean'

  return (
    <Container hidePadding>
      <Box p={3}>
        {!isResponseReady ? (
          <Typography variant='body2'>Redirecting ...</Typography>
        ) : (
          <Redirect to={isValid ? FP_QUICKBOOKS_URLS.success : FP_QUICKBOOKS_URLS.error} />
        )}
      </Box>
    </Container>
  )
})
